import type { ContestRubricSubmissionScoreCreateRequestApi } from 'api-typings/contests/contests';

/**
 * A rubric submission by a judge for an entry in a contest with the custom
 * judging upgrade. A rubric submission contains a list of rubric scores in a one-to-many mapping.
 * A judge is a contest collaborator with the ENTRY_JUDGE or ENTRY_VIEW_ALL_SCORES permission.
 *
 * @see https://phabricator.tools.flnltd.com/w/team/enterprise/core/custom-judging/
 */
export interface ContestRubricSubmission {
  readonly id: number;
  readonly entryId: number;
  readonly userId: number;
  readonly scores:
    | readonly ContestRubricSubmissionScore[]
    | readonly ContestRubricSubmissionScoreRequest[];
  readonly comment?: string;
  readonly rubricId?: number;
  readonly contestId?: number;
  // Used to delete the original submission after an upsert.
  readonly originalDocumentId?: number;
}

export interface ContestRubricSubmissionScore {
  readonly id: number;
  readonly submissionId: number;
  readonly contestRubricItemId: number;
  readonly score: number;
  readonly comment?: string;
}

export interface ContestRubricSubmissionScoreRequest {
  readonly contestRubricItemId: number;
  readonly score: number;
  readonly comment?: string;
}

export interface ContestRubricSubmissionCreateRequest {
  readonly comment?: string;
  readonly scores: readonly ContestRubricSubmissionScoreCreateRequestApi[];
}

export function isContestRubricSubmissionScoreArray(
  scores:
    | readonly ContestRubricSubmissionScore[]
    | readonly ContestRubricSubmissionScoreRequest[],
): scores is readonly ContestRubricSubmissionScore[] {
  if (scores.length === 0) {
    return true;
  }
  return 'id' in scores[0];
}
